module.exports = __webpack_public_path__ + "static/media/fail.43e7b921.png";